export default __webpack_public_path__ + "static/media/SWT1180.34I-43202_-25826_0.a657c2d7.jpg";